export default "/static/media/3df3459dd5441e8450270a21e56ef2a4.png";